export default __webpack_public_path__ + "static/media/sos-dia-09-11.f69c1d7c.webp";